<template src="./B2CPlans.html"></template>
<script>
import moment from "moment";
import mixins from "../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 10,
      planTypeSelected: null,
      plan: {},
      installment: false,
      numberInstallments: null,
      status: null,
      active: null,
      name: null,
      description: null,
      initialDate: null,
      finalDate: null,
      planValue: null,
      code: null,
      planIdIugu: null,
      companyId: null,
      company: null,
      planPackage: null,
      planPackages: [],
      partnerId: null,
      redirect: null,
      partners: [],
      clients: [],
      servicesAssociated: [],
      additionalLifeValue: null,
      additionalLifeMax: null,
      isCombo: false,
      period: null,
      method: null,
      planTypeId: null,
      planType: null,
      discount: null,
      options: null,
      multPlanCode: null,
      rootCampaign: null,
      businessType: null,
      initialDateFormated: null,
      finalDateFormated: null,
      disabledRadioB2C: false,
      disabledRadioB2B: true,
      showRowTypeCampaign: false,
      isDefaultPlan: false,
      isFreemium: false,
      clientId:null,
      freetrial: false,
      allowUpsell: false,
      amountDaysFreetrial: null,
      plansType: [
        { id: 1, description: "Plano individual" },
        { id: 2, description: "Plano plus" },
        { id: 3, description: "Plano por código" },
      ],
      businessTypeRd:[
        { id: 1, description: "B2B" },
        { id: 2, description: "B2C" },
        { id: 3, description: "B2B2C"},
        { id: 4, description: "B2C2C"}
      ],
      businessTypeRdStation: null,
      businessTypePartner: null,
      titlePopupPlans: "",
      showPagePlan: false,
      showlistPlans: true,
      plans: [],
      companies: [],
      periods: [
        { value: "mensais", text: "Mensal" },
        { value: "semestrais", text: "Semestral" },
        { value: "anuais", text: "Anual" },
        { value: "trimestrais", text: "Trimestral" },
        { value: "nonamestrais", text: "Nonamestral" },
      ],
      methods: [
        { value: "boleto", text: "Boleto bancário" },
        { value: "cartao", text: "Cartão de crédito" },
        { value: "pix",    text: "Pix" },
        { value: "pix,cartao", text: "Pix e Cartão de crédito" },
        { value: "pix,boleto", text: "Pix e Boleto" },
        { value: "boleto,cartao", text: "Boleto e Cartão de crédito" },
        { value: "todos", text: "Todos (Boleto, Pix e Cartão de crédito)" },
      ],
      invalidFields: {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        planValue: false,
        code: false,
        planTypeId: false,
        businessType: false,
        planIdIugu: false,
        companyId: false,
        period: false,
        method: false,
        discount: false,
        options: false,
        rootCampaign: false,
        multPlanCode: false,
        additionalLifeValue: false,
        planPackage: false,
        amountDaysFreetrial: false,
        additionalLifeMax: false,
        businessTypeRdStation: false,
        businessTypePartner: false,
      },
      saveClicked: false,
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      search: "",
      plansHistoric: [],
    };
  },
  watch: {
    name: function (newVal) {
      const vm = this;
      vm.invalidFields.name = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    description: function (newVal) {
      const vm = this;
      vm.invalidFields.description = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    isFreemium(val) {
      if (val) {
        this.planValue = "0,00"
      }
    },
    initialDateFormated: function () {
      const vm = this;
      if(vm.saveClicked) vm.validateDates();
    },
    finalDateFormated: function () {
      const vm = this;
      if(vm.saveClicked) vm.validateDates();
    },
    code: function (newVal) {
      const vm = this;
      vm.invalidFields.code = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planValue: function (newVal) {
      let vm = this;
      vm.invalidFields.planValue = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    businessType: function (newVal) {
      const vm = this;
      vm.invalidFields.businessType = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    period: function (newVal) {
      const vm = this;
      vm.invalidFields.period = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    method: function (newVal) {
      const vm = this;
      vm.invalidFields.method = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    rootCampaign: function (newVal) {
      const vm = this;
      vm.invalidFields.rootCampaign = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    discount: function (newVal) {
      const vm = this;
      vm.invalidFields.discount =vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    options: function (newVal) {
      const vm = this;
      vm.invalidFields.options = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    company: function(newVal) {
      const vm = this;
      vm.invalidFields.companyId = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
      vm.companyId = vm.invalidFields.companyId? null : newVal.id;
    },
    planType: function(newVal) {
      const vm = this;
      vm.invalidFields.planTypeId = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
      vm.planTypeId = vm.invalidFields.planTypeId? null : newVal.id;
      vm.isMultiple = vm.planTypeId === 3? true: vm.isMultiple;
    },
    planIdIugu: function (newVal) {
      const vm = this;
      vm.invalidFields.planIdIugu = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    multPlanCode: function (newVal) {
      const vm = this;
      vm.invalidFields.multPlanCode = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planPackage: function (newVal) {
      const vm = this;
      vm.invalidFields.planPackage = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    freetrial: function (newVal) {
      const vm = this;
      vm.invalidFields.freetrial = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    amountDaysFreetrial: function (newVal) {
      const vm = this;
      vm.invalidFields.amountDaysFreetrial = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    additionalLifeMax: function (newVal) {
      const vm = this;
      vm.invalidFields.additionalLifeMax = vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    businessTypeRdStation: function(newVal){
      const vm = this;
      vm.invalidFields.businessTypeRdStation = vm. testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    businessTypePartner: function(newVal){
      const vm = this;
      vm.invalidFields.businessTypePartner = vm. testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    currentx: function () {
      const vm = this;
      vm.changePage(vm.currentx);
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  computed: {
    plansPaginated() {
        // Lógica para calcular os planos a serem exibidos na página atual
        const startIndex = (this.currentPage - 1) * this.itemsPerPage;
        const endIndex = startIndex + this.itemsPerPage;
        return this.plans.slice(startIndex, endIndex);
    },
    totalPlans() {
        return this.plans.length; // Total de planos
    },
    totalPages() {
        return Math.ceil(this.totalPlans / this.itemsPerPage); // Cálculo do número total de páginas
    },
},
  methods: {
    init() {
      const vm = this;
      vm.getPlans();
      vm.getTypePlans();
      vm.getAllCompanies();
      vm.getPlanPackages();
      vm.getPartners();
    },
    removePlan(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "customerplan/" + id, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlans();
          }
        });
    },
    goToPlanList() {
      const vm = this;
      vm.showPagePlan = false;
      vm.showlistPlans = true;
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/companies?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
          }
        });
    },
    getAllCompanies() {
      this.axios
        .get(
          this.$store.state.filooServer +
            "admin/all-companies",
          {
            headers: { Authorization: this.$session.get("bearerDefault") },
          }
        )
        .then(response =>{
          if (response.status == 200) {
            this.companies = response.data;
          }
        });
    },
    getTypePlans() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearerDefault"
      );
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan/all-types")
        .then(function (response) {
          if (response.status === 200) {
            vm.plansType = response.data;
          }
        });
    },
    changeStatus(id, namePlan) {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "customerplan/change_status/" + id,
          {},
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Operação realizada!",
              "O status do plano <b style='color: #FF9F43; font-weight: 500'>" +
                namePlan +
                "</b> foi alterado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        });
    },
    getPartners() {
      const vm = this;
      
      vm.axios
        .get(vm.$store.state.filooServer + "partner/get-partners",{
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
        .then(function (response) {
          if (response.status === 200) {
            vm.partners = response.data;
            vm.clients = response.data;
          }
        });
    },
    editPlan(tr) {
      const vm = this;
      vm.showRowTypeCampaign = false;
      vm.titlePopupPlans = "Editar plano " + tr.name;
      vm.checkFalseInvalidFields();
      vm.getPlan(tr.id);
      
    },
    addNewPlan() {
      this.checkFalseInvalidFields();
      this.titlePopupPlans = "Adicionar novo plano";
      this.plan = {};
      this.isMultiple = false;
      this.status = null;
      this.active = null;
      this.name = null;
      this.description = null;
      this.initialDate = null;
      this.finalDate = null;
      this.planValue = null;
      this.code = null;
      this.planIdIugu = null;
      this.companyId = 2;
      this.isCombo = false;
      this.period = null;
      this.method = null;
      this.planTypeId = null;
      this.discount = null;
      this.options = null;
      this.multPlanCode = null;
      this.rootCampaign = null;
      this.businessType = "B2C";
      this.singleInstallment = 0;
      this.licensingTax = 0;
      this.nursingTax = 0;
      this.initialDateFormated = null;
      this.finalDateFormated = null;
      this.showPagePlan = true;
      this.showlistPlans = false;
      this.showRowTypeCampaign = false;
      this.period = null;
      this.planType = null;
      this.method = null;
      this.company = null;
      this.isDefaultPlan = false;
      this.freetrial = false;
      this.allowUpsell = false
      this.amountDaysFreetrial = 0;
      this.partnerId = null;
      this.installment = false;
      this.numberInstallments = null;
      this.redirect = null;
      this.planPackage = null;
      this.additionalLifeMax = null;
      this.businessTypeRdStation = null;
      this.businessTypePartner = null;
      this.clientId = null;
    },
    checkFalseInvalidFields() {
      const vm = this;
      vm.saveClicked = false;
      vm.invalidFields = {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        planValue: false,
        code: false,
        planTypeId: false,
        businessType: false,
        planIdIugu: false,
        companyId: false,
        period: false,
        method: false,
        discount: false,
        options: false,
        rootCampaign: false,
        multPlanCode: false,
        isCombo: false,
        isDefaultPlan: false,
        freetrial: false,
        planPackage: false,
        amountDaysFreetrial:false,
        additionalLifeMax:false,
        businessTypeRdStation: false,
        businessTypePartner: false,
      };
    },
    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage--;
        }
    },
    nextPage() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
        }
    },
    getPlans() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan", {
          params: {
            page: vm.currentx - 1,
            search: vm.search
          },
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            const plans = response.data.content;
            vm.plans = plans.filter(p => p.businessType == "B2C");
            vm.plansHistoric = vm.plans;
            vm.showlistPlans = true;
            vm.numPages = Math.ceil(response.data.totalElements / 10);
            vm.pagination = vm.numPages > 1;
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível listar os planos, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    dateFormatted(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    validateFields() {
      this.saveClicked = true
      this.invalidFields.businessType = !this.businessType
      this.invalidFields.name = !this.name
      this.invalidFields.description = !this.description
      this.invalidFields.planValue = this.planValue !== 0 && !this.planValue
      this.invalidFields.code = !this.code
      this.invalidFields.planTypeId = !this.planType
      this.invalidFields.period = !this.period
      this.invalidFields.method = !this.method
      this.invalidFields.planPackage = !this.planPackage || !this.planPackage.id
      this.invalidFields.additionalLifeValue = !this.additionalLifeValue
      this.invalidFields.additionalLifeMax = this.additionalLifeMax !== 0 && !this.additionalLifeMax
      this.invalidFields.businessTypeRdStation = !this.businessTypeRdStation
      this.invalidFields.businessTypePartner = !this.businessTypePartner
      this.invalidFields.partnerId = (!this.partnerId || !this.partnerId.id) && !this.isFreemium

      this.validateDates()

      if (this.businessType === "B2C") {
        this.invalidFields.discount = this.testNullUndefinedEmpty(this.discount)
        this.invalidFields.options = this.testNullUndefinedEmpty(this.options)
        this.invalidFields.companyId = this.testNullUndefinedEmpty(this.company)
      }

      const hasInvalids = Object.values(this.invalidFields).some((val) => val)

      if (hasInvalids) {
        this.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos!",
          color: "warning",
          icon: "error_outline",
          position: "top-right",
        })
      } else {
        this.plan.id ? this.updatePlan() : this.saveNewPlan()
      }
    },
    saveNewPlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      let plan = {
        status: true,
        active: true,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId:
          vm.businessType == "B2B" ? vm.$route.params.id : vm.companyId,
        isCombo: vm.isCombo,
        isFreemium: this.isFreemium,
        period: vm.period.value,
        planTypeId: vm.planTypeId,
        discount: vm.discount,
        options: vm.options,
        multPlanCode: vm.multPlanCode,
        rootCampaign: vm.rootCampaign,
        businessType: vm.businessType,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage: vm.planPackage,
        additionalLifeValue: parseFloat(vm.additionalLifeValue.replace(",", ".")),
        isDefaultPlan: vm.isDefaultPlan,
        freetrial: vm.freetrial,
        allowUpsell: this.allowUpsell,
        amountDaysFreetrial: vm.freetrial == 0  ? 0 : vm.amountDaysFreetrial,
        method: vm.freetrial == 1 ? "cartao" : vm.method.value,
        partnerId: vm.partnerId.id,
        installment: vm.period.value == "mensais" ? false : vm.installment,
        numberInstallments: vm.period.value == "semestrais" ? 6 : vm.period.value == "anuais" ? 12 : null ,
        additionalLifeMax: vm.additionalLifeMax,
        businessTypeRdStation: vm.businessTypeRdStation.description,
        businessTypePartner: vm.businessTypePartner.description,
        redirect: vm.redirect,
        clientId: vm.clientId ? vm.clientId.id : null,
       };
      vm.axios
        .post(vm.$store.state.filooServer + "customerplan/", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.showPagePlan = false;
            vm.$swal(
              "Operação realizada!",
              "O plano <b style='color: #FF9F43; font-weight: 500'>" +
                plan.name +
                "</b> foi criado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function (error) {
          if (error.response.status === 409){
            vm.$swal(
              "Atenção!",
              "Já existe um plano associado a este identificador. Por favor verifique os dados e tente novamente ",
              "error"
            );
          } else {
            vm.showPagePlan = false;
            vm.showlistPlans = true;
            vm.$swal(
              "Atenção!",
              "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
              "error"
            );
          }
        });
    },
    updatePlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      let plan = {
        id: vm.plan.id,
        status: vm.plan.status,
        active: vm.plan.status,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId:
          vm.businessType == "B2B" ? vm.$route.params.id : vm.companyId,
        isCombo: vm.isCombo,
        isFreemium: this.isFreemium,
        period: vm.period.value,
        planTypeId: vm.planTypeId,
        discount: vm.discount,
        options: vm.options,
        multPlanCode: vm.multPlanCode,
        rootCampaign: vm.rootCampaign,
        businessType: vm.businessType,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage: vm.planPackage,
        additionalLifeValue: parseFloat(vm.additionalLifeValue.replace(",", ".")),
        isDefaultPlan: vm.isDefaultPlan,
        freetrial: vm.freetrial,
        allowUpsell: vm.allowUpsell,
        amountDaysFreetrial: vm.freetrial == 0 ? 0 : vm.amountDaysFreetrial,
        method: vm.freetrial == 1 ? "cartao" : vm.method.value,
        partnerId: vm.partnerId.id,
        installment: vm.period.value == "mensais" ? false : vm.installment,
        numberInstallments: vm.period.value == "semestrais" ? 6 : vm.period.value == "anuais" ? 12 : null,
        additionalLifeMax: vm.additionalLifeMax,
        businessTypeRdStation: vm.businessTypeRdStation.description,
        businessTypePartner: vm.businessTypePartner.description,
        redirect: vm.redirect,
        clientId: vm.clientId.id,
       }
      vm.axios
        .put(vm.$store.state.filooServer + "customerplan", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.showPagePlan = false;
            vm.$swal(
              "Operação realizada!",
              "Os dados do plano <b style='color: #FF9F43; font-weight: 500'>" +
                vm.plan.name +
                "</b> foram alterados com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function () {
          vm.showPagePlan = false;
          vm.showlistPlans = true;
          vm.$swal(
            "Atenção!",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
            "error"
          );
        });
    },
    getPlan(idPlan) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "customerplan/find_by_id/" + idPlan,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.plan = response.data;
            vm.fillPlan();
          }
        })
        .catch(function () {
          vm.showPagePlan = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível localizar o plano selecionado, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    fillPlan() {
      const vm = this;
      console.log(this.plan)
      vm.initialDateFormated = "";
      vm.finalDateFormated = "";
      if (vm.testNullUndefinedEmpty(vm.plan.initialDate) === false) {
        vm.initialDateFormated = moment(String(vm.plan.initialDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (vm.testNullUndefinedEmpty(vm.plan.finalDate) === false) {
        vm.finalDateFormated = moment(String(vm.plan.finalDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (
        vm.testNullUndefinedEmpty(vm.plan.planValue) === false &&
        vm.plan.planValue != 0
      ) {
        let floatValue = parseFloat(vm.plan.planValue);
        let fixedValue = floatValue.toFixed(2);
        vm.planValue = fixedValue.toString().replace(".", ",");
      } else if (vm.plan.planValue == 0) {
        vm.planValue = vm.plan.planValue.toFixed(2);
      }
      vm.name = vm.plan.name;
      vm.active = vm.plan.active;
      vm.description = vm.plan.description;
      vm.code = vm.plan.code;
      vm.company = vm.companies.find(c => {return c.id === vm.plan.companyId;});
      vm.planType = vm.plansType.find(p => {return p.id === vm.plan.planTypeId;});
      vm.options = vm.plan.options;
      vm.period = vm.periods.find(p => {return p.value === vm.plan.period;});
      vm.method = vm.methods.find(m => {return m.value === vm.plan.method;});
      vm.rootCampaign = vm.plan.rootCampaign;
      vm.discount = vm.plan.discount;
      vm.multPlanCode = vm.plan.multPlanCode;
      vm.businessType = vm.plan.businessType;
      vm.isCombo = vm.plan.isCombo;
      vm.showPagePlan = true;
      vm.showlistPlans = false;
      vm.planIdIugu = vm.plan.planId;
      vm.planPackage = vm.planPackages.find(pack => {return pack.id === vm.plan.planPackageId});
      vm.additionalLifeValue = vm.plan.additionalLifeValue.toFixed(2);
      vm.additionalLifeMax = vm.plan.additionalLifeMax;
      vm.isDefaultPlan = vm.plan.isDefaultPlan;
      vm.freetrial = vm.plan.freetrial;
      vm.allowUpsell = vm.plan.allowUpsell;
      if(vm.plan.amountDaysFreetrial == "" || vm.plan.amountDaysFreetrial == 0 || vm.plan.amountDaysFreetrial == null || vm.plan.freetrial == 0){
        vm.plan.amountDaysFreetrial = "";
      }
      vm.amountDaysFreetrial = vm.plan.amountDaysFreetrial;
      vm.partnerId =  vm.partners.find(pack => {return pack.id === vm.plan.partnerId});
      vm.installment = vm.plan.installment;
      vm.redirect = vm.plan.redirect;
      vm.isFreemium = vm.plan.isFreemium;
      vm.businessTypeRdStation = vm.businessTypeRd.find(type => type.description === vm.plan.businessTypeRdStation);
      vm.businessTypePartner = vm.businessTypeRd.find(type => type.description === vm.plan.businessTypePartner);
      vm.clientId =  vm.clients.find(pack => {return pack.id === vm.plan.clientId});
    },
    dateFormattedUs(date) {
      const [day, month, year] = date.split("/")
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    validateDates() {
      const vm = this;
      const isValid = vm.dateIsBeforeAnotherDate(vm.initialDateFormated, vm.finalDateFormated);
      vm.invalidFields.initialDate = !isValid || vm.testNullUndefinedEmpty(vm.initialDateFormated);
      vm.invalidFields.finalDate = !isValid || vm.testNullUndefinedEmpty(vm.finalDateFormated);
    },
    changePage(pageNumber) {
      this.currentx = pageNumber;
      this.getPlans();
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    getPlanPackages() {
      const vm = this;
      vm.axios.get(`${this.$store.state.filooServer}plan-package`,
        { headers: { Authorization: this.$session.get("bearerDefault") }, } )
        .then( res => {
          if (res.status === 200) {
            vm.planPackages = res.data;
          }
        })
        .catch( err => {
          console.log({
            endpointURL: "plan-package",
            error_getPlanPackages: err,
          });
        });
    },
    handleSearch(search) {
      this.search = search
      this.getPlans()
    },
  },
};
</script>

<style lang="scss" src="./B2CPlans.scss">
</style>
